import { Injectable } from '@angular/core';
import { FileResponse } from '../model/file';

@Injectable({
  providedIn: 'root'
})
export class FileSaverService {
  save(file: FileResponse, mimeType = 'application/pdf') {
    this.doDownload(file.content, file.name, mimeType);
  }

  private doDownload(content: string, fileName: string, mimeType: string) {
    const byteArray: Uint8Array = this.base64ToArrayBuffer(content);

    var blob = new Blob([byteArray], {type: mimeType});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    link.remove();
  }

  private base64ToArrayBuffer(base64: string): Uint8Array {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);

    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    return bytes;
  }
}
